import { ApiVenueDetail, ApiZone, ClimbType } from "griptonite-api-client";

export type SetType =
  | "circuit"
  | "zone"
  | "sportZone"
  | "customBoulder"
  | "sport"
  | "misc"
  | "competition";

type TypeChoice = {
  name: string;
  value: SetType;
};

export default function getSetTypeChoices(
  venue?: ApiVenueDetail,
  zones?: ApiZone[],
  sportZones?: ApiZone[],
): TypeChoice[] {
  const typeChoices: TypeChoice[] = [];
  if (venue?.climbTypes.includes("BOULDER")) {
    typeChoices.push({ name: "Circuit", value: "circuit" });
    if (zones?.length) {
      typeChoices.push({ name: "Zone", value: "zone" });
    }
    typeChoices.push({
      name: venue.climbTypes.length === 2 ? "Custom Bouldering" : "Custom",
      value: "customBoulder",
    });
  }
  if (venue?.climbTypes.includes("SPORT")) {
    typeChoices.push({
      name: "Sport",
      value: "sport",
    });
    if (sportZones?.length) {
      typeChoices.push({ name: "Sport Sector", value: "sportZone" });
    }
  }
  typeChoices.push({
    name: "Housekeeping",
    value: "misc",
  });
  return typeChoices;
}

/**
 * The climb type a set of the given type creates routes for. Returns
 * `undefined` for competition sets, whose climb type comes from the
 * competition itself.
 */
export function getClimbTypeForSetType(type: SetType): ClimbType | null | undefined {
  switch (type) {
    case "circuit":
    case "zone":
    case "customBoulder":
      return "BOULDER";
    case "sport":
    case "sportZone":
      return "SPORT";
    case "misc":
      return null;
    case "competition":
      return undefined;
  }
}
